import { holidayConstants } from '../constants/holiday.constants';

export function holiday(state = {}, action) {
  switch (action.type) {
    case holidayConstants.CREATE_REQUEST:
    case holidayConstants.UPDATE_REQUEST:
    case holidayConstants.FETCH_REQUEST:
    case holidayConstants.GET_REQUEST:
    case holidayConstants.REMOVE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case holidayConstants.CREATE_SUCCESS:
    case holidayConstants.GET_SUCCESS:
    case holidayConstants.UPDATE_SUCCESS:
      return {
        ...state,
        holiday: action.holiday,
        loading: false
      };
    case holidayConstants.FETCH_SUCCESS:
      return {
        ...state,
        holidays: action.holidays,
        loading: false
      };
    case holidayConstants.REMOVE_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case holidayConstants.CREATE_FAILURE:
    case holidayConstants.FETCH_FAILURE:
    case holidayConstants.GET_FAILURE:
    case holidayConstants.REMOVE_FAILURE:
    case holidayConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}
